<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="7" :lg="8" :md="9" :sm="24">
            <a-form-item label="基金经理姓名">
              <a-input
                placeholder="请输入基金经理姓名"
                v-model="queryParam.managerName"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="disManager()" type="primary" icon="plus"
        >分配投资经理</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />批量删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleDelete(record.id)">删除</a>
        </span>
      </a-table>
    </div>
    <add-manager ref="managerForm" v-on:getList="getList"></add-manager>
    <edit-manager ref="editForm" @ok="modalFormOk"></edit-manager>

    <!-- <investmentManagerModal
      ref="modalForm"
      @ok="modalFormOk"
    ></investmentManagerModal> -->
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import addManager from '../addManager.vue';
import editManager from '../../manager/add.vue';
// import investmentManagerModal from './investmentManagerModal.vue';
import customRender from '@/utils/customRender.js';
import { getManagerList } from '@/api/product';
import { postAction, postTag } from '../../../../api/manage';

export default {
  components: {
    editManager,
    addManager,
  },
  data() {
    return {
      loading: false,
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      queryParam: {
        manaId: '',
        managerName: '',
      },
      dataSource: [],
      selectedRowKeys: [],
      selectionRows: [],
      // 表头
      columns: [
        {
          title: '基金经理姓名',
          align: 'center',
          dataIndex: 'managerName',
          customRender: customRender,
        },
        {
          title: '职位',
          align: 'center',
          dataIndex: 'duty',
          customRender: customRender,
        },
        {
          title: '简介',
          align: 'center',
          dataIndex: 'managerIntroduction',
          ellipsis: true,
          customRender: customRender,
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/manager/page',
        delete: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/manager/del',
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/manager/delList',
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    disManager() {
      this.$refs.managerForm.handleVisible(this.$route.query.fundCode);
      this.$refs.managerForm.fundCode = this.$route.query.fundCode;
      // let that = this;
      // that.$refs.managerForm.initManagerByFundCode(this.producManager);
    },
    // 获取数据
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        pageNo: that.ipagination.current,
        pageSize: that.ipagination.pageSize,
        fundCode: this.$route.query.fundCode,
        // managerName: ''
      };
      if (this.queryParam.managerName != '') {
        params.managerName = this.queryParam.managerName;
      }
      that.loading = true;
      postTag(this.url.list, params).then((res) => {
        if (res.success) {
          that.dataSource = res.result.records;
          that.loading = false;
          that.ipagination.total =
            res.result && res.result.total ? res.result.total : 0;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },

    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        let ids = this.selectedRowKeys.join(',');
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            let formData = new FormData();
            formData.append('ids', ids);
            postTag(that.url.deleteBatch, formData).then((res) => {
              that.loading = false;
              if (res.success) {
                that.$message.success(res.message);
                that.getList();
                that.onClearSelected();
              } else {
                that.$message.error(res.message);
              }
            });
          },
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //删除
    handleDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function () {
          that.loading = true;
          let formData = new FormData();
          formData.append('id', id);
          postTag(that.url.delete, formData).then((res) => {
            that.loading = false;
            if (res.success) {
              that.getList();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        },
      });
    },
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
